module.exports = __webpack_public_path__ + "filetype-document.svg?0fb3f37d066af9adf6e854d6a5147ab8";